import copy from 'copy-to-clipboard';

const initCopyURL = async () => {

  const copyBtn = document.querySelector('#copyUrlButton')

  if (! copyBtn) {
    return;
  }

  copyBtn.addEventListener('click', () => {
      copy(window.location.href);
      copyBtn.querySelector('.tooltiptext').textContent = "کپی شد!"
      setTimeout(() => {
        copyBtn.querySelector('.tooltiptext').textContent = "کپی URL"
      }, 1500)
  })
}

export {initCopyURL}